import { useContext } from "react";
import { useNavigate } from "react-router-dom";

import { Confirmation } from "../../../../../../shared/components";

import {
  displayErrorMessage,
  displayNotImplementedMessage,
  downloadBase64Files,
  formattedPrice,
  getUserInfo,
} from "../../../../../../shared/utils";

import { WizardDataFormContext } from "../../../Wizard/contexts/WizardDataForm";
import { GenericDataFormContext } from "../../contexts/GenericDataForm";
import { FILE_TYPES, UserInformation } from "../../../../../../shared/interfaces";
import PreLiquidationService from "../../../../../../shared/services/collection/preliquidation";
import dayjs from "dayjs";
import userHelper from "../../../../../../shared/utils/userHelper";
import { StepThreeFormContext } from "../../../Steps/StepThree/contexts/StepThreeForm";
import { PaymentListValues } from "../../interfaces/services/get-payments-list-service.interface";

export const ConfirmationPreliquidation = () => {
  const navigate = useNavigate();

  const { showSecondaryButton } = useContext(WizardDataFormContext);
  const { preliquidationInfo, selectedQuotas } = useContext(
    GenericDataFormContext
  );
  const { paymentsList, paymentsToLoad, paymentMethods, banksOptions, allBanksOptions } = useContext(StepThreeFormContext);

  const onPressConfirm = () =>
    navigate("/cobranzas/preliquidaciones-guardadas");

  const onPressDownloadPdf = async () => {
    const totalValue = selectedQuotas?.cuotas?.reduce(
      (acc, quote) => acc + Number(quote.importePesos),
      0
    );
    
    let paymentsToRender:PaymentListValues[]  = paymentsToLoad.map(e => {   
      let bankText = "";  
      let checkNumber = "0";
      if(e.newPaymentMethod == 3){
        bankText = e.basePaymentMethodData.observaciones
        checkNumber = "";
      }else if(e.newPaymentMethod == 5) {
        bankText = allBanksOptions?.find(item => String( e.basePaymentMethodData.codigoBanco) === item.value)?.label!
        checkNumber = e.basePaymentMethodData.numeroCheque;
      }else{
        bankText = banksOptions?.find(item => String( e.basePaymentMethodData.codigoBanco) === item.value)?.label!
      }

      return {
        importe: e.basePaymentMethodData.monto,
        fecha: e.basePaymentMethodData.fecha,
        nroCheque: checkNumber,
        formaDePago: paymentMethods?.find(item => String(e.newPaymentMethod) === item.value)?.label!,
        banco: bankText,
        archivo: e.basePaymentMethodData.archivo,
        codigoFormaDePago: e.newPaymentMethod
      };
    })
    
    paymentsToRender = paymentsToRender.concat(paymentsList)

    paymentsToRender = paymentsToRender.map(e => {
      return {
        ...e,
        importe: `$${formattedPrice(e.importe)}`,
        fecha: dayjs(e.fecha).format("DD/MM/YYYY")
      }
    })

    const { intermediarioPrincipal }: UserInformation = userHelper.getUser()!;

    let hasRounding = false;
    paymentsToRender.forEach((payment) => {
      if(payment.formaDePago === "REDONDEO" || payment.formaDePago === "REDONDEDO") {
        hasRounding = true;
      }
    });
    
    const response = await PreLiquidationService.generatePreliquidationPdf({
      fechaVence: dayjs().format("DD/MM/YYYY"),
      fechaYHora: dayjs().format("DD/MM/YYYY"),
      nombreInter: intermediarioPrincipal?.nombreInter!,
      codigoInter: intermediarioPrincipal?.codigoInter!,
      numeroPreliquidacion: preliquidationInfo?.numeroPreliquidacion!,
      preliquidacion: selectedQuotas?.cuotas || [],
      productor: intermediarioPrincipal!,
      cma:  `${intermediarioPrincipal?.codMayorAux}-${intermediarioPrincipal?.nroMayorAux}`,
      formasDePagoSeleccionadas: paymentsToRender,
      total: `$ ${formattedPrice(`${totalValue}` || "0")}`,
      redondeoUsado: hasRounding,
    });

    if (response.data) {
      downloadBase64Files(
        response.data.base64,
        "preliquidacionGenerada.pdf",
        FILE_TYPES.PDF
      );
    } else {
      displayErrorMessage("No se pudo generar el PDF de la preliquidación.");
    }
  };

  return (
    <Confirmation
      title={
        showSecondaryButton
          ? `La preliquidación ${preliquidationInfo?.numeroPreliquidacion} ha sido guardada y estará disponible por 48 horas. Muchas gracias.`
          : `La preliquidación ${preliquidationInfo?.numeroPreliquidacion} ha sido enviada con éxito a la compañía. Muchas gracias.`
      }
      {...(!showSecondaryButton && {
        secondaryButtonConfirm: { label: "Generar PDF" },
        onPressSecondary: onPressDownloadPdf,
      })}
      onPressConfirm={onPressConfirm}
    />
  );
};
